import styled from 'styled-components';
import { IStyledContainer, IStyledDot } from './Carousel.interface';

export const StyledDotIndicators = styled('span')<IStyledDot>(
  ({ isActive }) => ({
    background: isActive ? '#FFF' : 'lightgray',
    height: isActive ? '8px' : '7px',
    width: isActive ? '8px' : '7px',
  }),
);

export const StyledContainer = styled('div')<IStyledContainer>(({ color }) => ({
  backgroundColor: color,
}));
